import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  NotificationPreference,
  NotificationPreferencePayload,
  NotificationPreferencesListResponse,
} from '../dto/notfication-preference';
import { Accounts, AccountType } from '../models/account';

@Injectable({
  providedIn: 'root',
})
export class NotificationPreferenceService {
  private accountNotificationsEndpoint: string = `${environment.baseUrl}${environment.accountsUrl}/notification-preferences`;
  private clientNotificationsEndpoint: string = `${environment.baseUrl}${environment.coreUrl}notification-preferences`;

  constructor(private httpClient: HttpClient) {}

  private getEndpointUrl(accountType: AccountType): string {
    return accountType === Accounts.CLIENT || accountType === Accounts.CORPORATE
      ? this.clientNotificationsEndpoint
      : this.accountNotificationsEndpoint;
  }

  public getNotificationPreferences(
    accountType: AccountType,
    accountId: number,
    clientType?: string
  ): Observable<NotificationPreferencesListResponse> {
    const params = (accountType === Accounts.CLIENT || accountType === Accounts.CORPORATE)
      ? { clientType: clientType || 'INDIVIDUAL' }
      : { accountType };

    return this.httpClient.get<NotificationPreferencesListResponse>(
      `${this.getEndpointUrl(accountType)}/${accountId}`,
      { params }
    );
  }

  updateNotificationPreference(
    accountType: AccountType,
    payload: NotificationPreferencePayload
  ): Observable<NotificationPreference> {
    return this.httpClient.put<NotificationPreference>(
      this.getEndpointUrl(accountType),
      payload
    );
  }
}
